var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSun = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.333
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 9.333a2.333 2.333 0 1 0 0-4.666 2.333 2.333 0 0 0 0 4.666ZM7 1.167v1.166M7 11.667v1.166M2.876 2.876l.822.822M10.302 10.302l.822.822M1.167 7h1.166M11.667 7h1.166M3.698 10.302l-.822.822M11.124 2.876l-.822.822"
}))));
SvgSun.viewBox = '0 0 14 14';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSun);
export default ForwardRef;